<template>
  <v-expansion-panel class="pt-2">
    <v-expansion-panel-header class="expansion--panel">
      <template>
        <v-row no-gutters>
          <v-col cols="4"><v-icon color="white">mdi-cart-plus</v-icon> {{ $t("message.warehouse.openOrders") }}</v-col>
        </v-row>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="pt-2">
      <data-list :payload="modelObj" :headers="headers"></data-list>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import DataList from '../../components/DataList.vue'
import CONSTANTS from '@/utils/warehouse.json'
export default {
  components: {
    DataList
  },
  props: {
    model: {
      type: Object
    }
  },
  data () {
    return {
      modelObj: {
        isHeader: true,
        isHideAdd: false,
        hasFilters: true,
        selection: [],
        editProp: 'ordernumber',
        editURL: (item) => this.navigateToOrder(item),
        list: [],
        loading: true,
        page: 1
      },
      dataLoading: false
    }
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('message.order.orderNumber'),
          value: 'ordernumber',
          width: '10%'
        },
        {
          text: `${this.$t('message.order.customer')}`,
          value: 'customername',
          width: '20%'
        },
        {
          text: `${this.$t('message.order.qty')}`,
          value: 'qty',
          align: 'right',
          width: '10%'
        },
        {
          text: `${this.$t('message.whOrder.orderDate')}`,
          value: 'orderdate',
          width: '15%'
        },
        {
          text: `${this.$t('message.whOrder.estimateDelivery')}`,
          value: 'estimatedeliverydate',
          width: '10%'
        }
      ]
    }
  },
  mounted () {
    this.getListHandler()
  },
  methods: {
    getListHandler () {
      this.modelObj.loading = true
      this.$_executeApi('get', `stocks/get_open_orders/${this.model.id}`)
        .then((response) => {
          let transformData = { number: { list: ['qty'], format: 'replaceDotWithComma' },
            date: { list: ['estimatedeliverydate', 'orderdate'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' } }
          let model = this.$_formatListModel(response.data, transformData)
          this.modelObj.list = model
          this.modelObj.loading = false
        })
    },
    navigateToOrder (item) {
      if (item.type === CONSTANTS.SUPPLIER) {
        return `/w_h/order/supplierorder/actions/${item.orderid}`
      } else if (item.warehouseorder_type === CONSTANTS.ADJUSTMENT) {
        return `/w_h/order/adjustmentorder/actions/${item.orderid}`
      } else if (item.warehouseorder_type === CONSTANTS.RETURN) {
        return `/w_h/order/returnorder/actions/${item.orderid}`
      } else if (item.warehouseorder_type === CONSTANTS.TRANSFER) {
        return `/w_h/order/transferorder/actions/${item.orderid}`
      } else if (item.type === CONSTANTS.CUSTOMER_ORDER) {
        return `/orders/edit/${item.orderid}/materials`
      }
    }
  }
}
</script>
